import { CSSProp, StyledProps } from 'styled-components';

export function variant(
  variants: Record<string, CSSProp>,
  variantPropName: string
) {
  return (props: StyledProps<any>) => {
    const variantKey = props[variantPropName];
    return variants[variantKey];
  };
}
